import(/* webpackMode: "eager", webpackExports: ["ActionBar"] */ "/app/apps/PublicUI/components/CourseInfoHeader/ActionBar/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/PublicUI/components/CourseInfoHeader/CoverPhoto/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/PublicUI/components/CourseInfoHeader/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/PublicUI/app/~minisites~/[subdomain]/[course_param]/(course_header)/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
